import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, onMounted, watch } from "vue";
import { useI18n } from "vue3-i18n";
import { store } from "@/store/store";
import { useRouter } from "vue-router";
import PcFileDataService from "@/services/PcFileDataService";
import Loading from "@/components/home/Loading";


export default /*#__PURE__*/_defineComponent({
  emits: ["ChangeAlertState", "alertMessageValue"],
  setup(__props, { expose, emit }) {
  expose();

const router = useRouter();
const i18n = useI18n();
const isLoading = ref(false);
const alertMessage = ref("");
const isUpload = ref(true);
const companyData = reactive([]);
const uploadFiles = reactive([]);
const fileInfo = reactive([]);
const uploadHistoryInfo = reactive([]);
const isEnter = ref(false);
const fromStationCode = ref("");
const isActive = ref(false);

const garbledError = ref("");

onMounted(function () {
  companyData.push(store.getters.stationListData);
});

/** PC Downloadのページに遷移する関数 */
const linkPcDownload = () => {
  router.push("/PcDownload");
};

/** File Formatの有無を監視する */
watch(
  () => [store.getters.fileFormatListData],
  function () {
    if(store.getters.fileFormatListData == null){
      isLoading.value = true;
    }else{
      isLoading.value = false;
    }
  }
);

/** ファイル選択時の処理関数 */
const selectFile = async (event: {
  target: { files: any };
  dataTransfer: { files: any };
}) => {
  emit("ChangeAlertState", "neutral");
  isEnter.value = false;
  // ファイル選択ボタン→event.target.files
  // ドラッグアンドドロップ→event.dataTransfer.files
  const fileList = event.target.files
    ? event.target.files
    : event.dataTransfer.files;

  let totalFileSize = 0;

  //アップロードされたファイルをuploadFilesに保存
  for (let i = 0; i < fileList.length; i++) {
    uploadFiles.push(fileList[i]);
  }

  for (let j = 0; j < uploadFiles.length; j++) {
    totalFileSize = totalFileSize + uploadFiles[j].size;
    if (uploadFiles[j].size > 1024 * 1024 * 5) {
      alertMessage.value = i18n.t("alt009").replaceAll("{restrictSize}", "5") + fromStationCode.value + "(" + uploadFiles[j].name + ")";
      alert(alertMessage.value);
      spliceAllData();
    } else {
      if (totalFileSize > 1024 * 1024 * 30) {
        alertMessage.value = i18n.t("alt009").replaceAll("{restrictSize}", "30");
        alert(alertMessage.value);
        spliceAllData();
      }
    }
  }

  if (uploadFiles.length != 0) {
    isActive.value = true;
  }
};


/** 選択したファイルを取り消す関数 */
const fileCancel = (index: number) => {
  uploadFiles.splice(index, 1);
  if (uploadFiles.length === 0) {
    isActive.value = false;
  }
};

/** DBに選択したファイルをアップロードする関数 */
const pcUpload = async () => {
  isUpload.value = true;
  uploadHistoryInfo.splice(0);
  fileInfo.splice(0);
  await createFileInfo();
};

const changeLoading = () => {
  isLoading.value = true;
  window.setTimeout(pcUpload, 50);
};

/** 選択したファイルの内容を読みだす関数 */
const createFileInfo = () => {
  // 選択されたファイルのチェック済み数
  let checkFileCount = 0;
  var fileFormatList = store.getters.fileFormatListData;
  // 一拠点のデータ登録データ(fromStationCode,dataId,toStationCode,refNumber,fileBody)
  let headerFromStation = "", headerDataId = "", headerToStation = "", refNumber = "", oneStationReadyData = "";
  // データチェック用の変数
  let fromStationList = [], toStationList = [], splitHeaderData = [], oneStationData = "", oneStationSplitData = [];
  let lineBreakFormat = "", spaceCheckValue = "".padEnd(80, " ");
  let isUploadOk = false, emptyRowIndex = -1, errorMessage = "";
  let selectedFromStation = store.getters.selectedStation;
  garbledError.value = "";

  for (let fileIndex = 0; fileIndex < uploadFiles.length; fileIndex++) {
    let file = uploadFiles[fileIndex];
    let fileReader = new FileReader()
    fileReader.readAsText(file)
    fileReader.onload = () => {
      let fileContent = fileReader.result;
      var contentLength = fileContent.length;
      var contentSize = new Blob([fileContent]).size;
      checkFileCount++;
      if (contentLength == 0) {
        // データが含まれないファイルかチェック
        errorMessage = i18n.t("alt003") + "(" + file.name + ")";
        alert(errorMessage);
      } else if (contentLength != contentSize) {
        // 各行に1Byte以上の文字が含めるか確認
        var lineBreakIndex = fileContent.indexOf("\r\n");
        lineBreakFormat = "\r\n";
        if (lineBreakIndex == -1) {
          lineBreakIndex = fileContent.indexOf("\r");
          lineBreakFormat = "\r";
          if (lineBreakIndex == -1) {
            lineBreakIndex = fileContent.indexOf("\n");
            lineBreakFormat = "\n";
          }
        }
        var garbledData = fileContent.split(lineBreakFormat);
        var lineByteSize, lineCharCount = 0;
        var lineString = "";
        var errCharValue = "";

        for(let idxLine=0; idxLine < garbledData.length; idxLine++){
          lineByteSize = new Blob([garbledData[idxLine]]).size;
          lineCharCount = garbledData[idxLine].length;
          if(lineByteSize != lineCharCount){
            errCharValue = errCharValue + "Line: " + (idxLine + 1) + "\nColumn: ";
            lineString = garbledData[idxLine];
            for(let idxChr = 0; idxChr < lineString.length; idxChr++){
              if(new Blob([lineString[idxChr]]).size != 1){
                errCharValue = errCharValue + (idxChr + 1) + ",";
              }
            }
            errCharValue = errCharValue.substr(0, errCharValue.length-1)  + "\n";
          }
        }
        garbledError.value = garbledError.value + i18n.t("alt090") + "(" + file.name + ")\n" + errCharValue + "\n";
      } else {
        if (!fileContent.startsWith("HHHH")) {
          var strHeaderValue = contentLength >= 4 ? fileContent.substring(0, 4) : fileContent?.toString();
          errorMessage = "Header error." + strHeaderValue + " is not registered in system.\n" + "(" + file.name + ")";
          errorMessage = i18n.t("alt087").replaceAll("{headerValue}", strHeaderValue) + "(" + file.name + ")";
          alert(errorMessage);
        } else {
          var fileDataIndex = fileContent.indexOf("\r\n");
          lineBreakFormat = "\r\n";
          if (fileDataIndex == -1) {
            fileDataIndex = fileContent.indexOf("\r");
            lineBreakFormat = "\r";
            if (fileDataIndex == -1) {
              fileDataIndex = fileContent.indexOf("\n");
              lineBreakFormat = "\n";
            }
          }
          fileContent = fileContent.replaceAll(lineBreakFormat + "HHHH", lineBreakFormat + "HHHHHHHH").trim();
          // 'HHHH'と改行コードによって拠点ごとのデータを取得する
          splitHeaderData = [];
          splitHeaderData = fileContent.split(lineBreakFormat + "HHHH");
          for (let headerIndex = 0; headerIndex < splitHeaderData.length; headerIndex++) {
            // 一拠点向けのデータをチェックする
            oneStationData = "";
            oneStationData = splitHeaderData[headerIndex];
            if (oneStationData.length < 16) {
              // ヘッダ情報が【HHHH{from:4桁}{dataId:4桁}{toStation:4桁}】フォーマットを満たすかチェック)
              errorMessage = i18n.t("alt089") + "(" + file.name + ")";
              alert(errorMessage);
            } else {
              headerFromStation = "", headerDataId = "", headerToStation = "";
              headerFromStation = oneStationData.substring(4, 8);
              headerDataId = oneStationData.substring(8, 12);
              headerToStation = oneStationData.substring(12, 16);
              if (headerFromStation != selectedFromStation) {
                // アップロードされたファイルのfromStationと画面上選択されたfromStatonが一致するかチェック
                errorMessage = i18n.t("alt006") + headerFromStation + "(" + file.name + ")";
                alert(errorMessage);
              }
              fromStationList = companyData[0].filter((obj: { stationCode: any; }) => obj.stationCode == headerFromStation);
              if(fromStationList.length < 1){
                // fromStationが拠点マスタに存在するかチェック
                errorMessage = i18n.t("alt007") + headerFromStation + "(" + file.name + ")";
                alert(errorMessage);
              }
              toStationList = companyData[0].filter((obj: { stationCode: any; }) => obj.stationCode == headerToStation);
              if(toStationList.length < 1){
                // toStationが拠点マスタに存在するかチェック
                errorMessage = i18n.t("alt007") + headerToStation + "(" + file.name + ")";
                alert(errorMessage);
              }

              oneStationSplitData = [];
              oneStationSplitData = oneStationData.split(lineBreakFormat);
              if (oneStationSplitData.length == 1) {
                // ヘッダ情報だけなく、内容も含めるようにチェック
                errorMessage = i18n.t("alt010") + "(" + file.name + ")";
                alert(errorMessage);
              } else {
                oneStationReadyData = "";
                for (let oneRowIndex = 0; oneRowIndex < oneStationSplitData.length; oneRowIndex++) {
                  if(oneStationSplitData[oneRowIndex].length > 80){
                    errorMessage = i18n.t("alt008") + "(" + file.name + ")";
                    alert(errorMessage);
                    break;
                  }
                  oneStationSplitData[oneRowIndex] = oneStationSplitData[oneRowIndex].padEnd(80, " ");
                  // 注意：ローカル実行するとき、SQLite3のクエリのみ使う
                  // oneStationReadyData = oneStationReadyData + oneStationSplitData[oneRowIndex] + "forcelinebreak";
                  oneStationReadyData = oneStationReadyData + oneStationSplitData[oneRowIndex] + "\r\n";
                }
                emptyRowIndex = oneStationReadyData.indexOf(spaceCheckValue);
                if (emptyRowIndex > -1 && emptyRowIndex != (oneStationReadyData.length - 80)) {
                  // 空欄の行が含まれないようにチェック
                  errorMessage = i18n.t("alt088") + "(" + file.name + ")";
                  alert(errorMessage);
                } else if (errorMessage == "") {
                  var fileFormat = fileFormatList.filter((obj: { dataId: any; }) => obj.dataId == headerDataId);
                  refNumber = "";
                  if (fileFormat.length > 0) {
                    var refIndex = oneStationReadyData.indexOf("\r\n" + fileFormat[0].recordId);
                    if (refIndex > -1) {
                      refNumber = oneStationReadyData.substr((refIndex + 1) + fileFormat[0].startPosition, fileFormat[0].digitCount);
                    }
                  }
                  // チェックOKの登録データの準備
                  fileInfo.push({
                    fromStationCode: headerFromStation,
                    toStationCode: headerToStation,
                    dataId: headerDataId,
                    fileBody: oneStationReadyData,
                    isDownloaded: false,
                    refNumber: refNumber
                  });
                  if (checkFileCount == uploadFiles.length && headerIndex == (splitHeaderData.length -1)) {
                    isUploadOk = true;
                  }
                }
              }
            }
          }
        }
      }
      if (isUploadOk && garbledError.value == "") {
        isLoading.value = true;
        uploadHistoryInfo.push({
          uploadDate: new Date(),
          uploadUserId: store.getters.cognitoUserName
        })
        PcFileDataService.upload([fileInfo, uploadHistoryInfo])
          .then(() => {
            alertMessage.value = i18n.t("suc001");
            emit("ChangeAlertState", "success");
            emit("alertMessageValue", alertMessage.value);
            spliceAllData();
            isLoading.value = false;
          })
          .catch((e: Error) => {
            alertMessage.value = i18n.t("err001");
            emit("alertMessageValue", alertMessage.value);
            emit("ChangeAlertState", "error");
            isLoading.value = false;
            fileInfo.splice(0);
            uploadHistoryInfo.splice(0);
            console.log(e);
          });
      } else if (checkFileCount == uploadFiles.length) {
        if(garbledError.value != ""){
          document.getElementById("btnGarbledShow").click();
        }
        isLoading.value = false;
      }
    }
  }
};

/** アップロード成功時に格納されているデータを削除する関数 */
const spliceAllData = () => {
  uploadFiles.splice(0);
  fileInfo.splice(0);
  uploadHistoryInfo.splice(0);
  isActive.value = false;
};

const __returned__ = { router, i18n, isLoading, alertMessage, isUpload, companyData, uploadFiles, fileInfo, uploadHistoryInfo, isEnter, fromStationCode, isActive, emit, garbledError, linkPcDownload, selectFile, fileCancel, pcUpload, changeLoading, createFileInfo, spliceAllData, Loading }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})